
import { useState, useContext, useMemo } from 'react';
import ServiceContext from '../../../../data/ServiceContext';
import { useNavigate } from "react-router-dom";
import Form from '../../../Helpers/Form/Form';
import NotificationType from '../../../Helpers/Notification/NotificationType';
import MessageContext from '../../../../utils/messages/message-context';
import { Validator } from '../../../../data/model/validator';
import { changePasswordRules } from '../../../../data/model/rules';

export default function ChangePasswordForm() {
    const { loginService, notificationService } = useContext(ServiceContext);
    const messages = useContext(MessageContext);
    const [errors, setErrors] = useState<string[]>([]);
    const navigate = useNavigate();
    const passwordData = { password: '', newPassword: '', repeatPassword: '' };

    const validator = useMemo(() => new Validator(changePasswordRules(messages)), [messages]);

    const inputs = {
        password: {
          type: 'input',
          label: messages.PASSWORD,
          props: { type: 'password', autoComplete: 'current-password' }
        },
        newPassword: {
          type: 'input',
          label: messages.NEW_PASSWORD,
          props: { type: 'password', autoComplete: 'new-password' }
        },
        repeatPassword: {
            type: 'input',
            label: messages.REPEAT_PASSWORD,
            props: { type: 'password', autoComplete: 'off' }
        }
    };

    function saveForm(data: any) {
        loginService.changePassword(data).then((result: any) => {
            if (result?.data?.errors) {
                setErrors(result.data.errors);
            } else {
                navigate('/');
                notificationService.show(NotificationType.Success, messages.SAVED_CHANGES);
            }
        }).catch((result) => {
            if (result.response.status === 401) {
                setErrors([messages.WRONG_CREDENTIALS]);
            } else {
                notificationService.show(NotificationType.Error, messages.ERROR_OCCURED);
            }
        });
    }

    return (
        <Form model={passwordData} inputs={inputs} validator={validator} onSave={saveForm}
            saveText={messages.ENTER} modelErrors={errors}/>
    );
}